export const getRelevantCabinetId = () => sessionStorage.getItem('cabinet-id');
